import { PlusIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { CardAction } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { useCompanyPath, useIdCompany, useRBAC } from '@/lib/hooks'

type Props = {
  filterTerm: string
  setFilterTerm: (term: string) => void
}

export const RegistryCredentialsTableHeader = ({
  filterTerm,
  setFilterTerm,
}: Props) => {
  const { navigateToPath } = useCompanyPath()
  const { idCompany } = useIdCompany()
  const { rbac } = useRBAC()

  return (
    <CardAction className="w-full px-6 flex items-center gap-2 justify-between">
      <Input
        autoFocus
        placeholder="Filter by name..."
        aria-label="Filter registry credentials by name"
        value={filterTerm}
        onChange={(e) => setFilterTerm(e.target.value)}
        className="max-w-sm"
      />
      {rbac.company(idCompany).apps.view.can() ? (
        <Button
          onClick={() =>
            navigateToPath({
              pathname: '/registry-credentials/create',
              options: { replace: true },
            })
          }
        >
          <PlusIcon aria-hidden="true" /> Create registry credential
        </Button>
      ) : null}
    </CardAction>
  )
}
